export const LABELS_INFO_DRAWER_ID = "labels-info";
